import { ProgramBroadcastFiltersState } from '@/stores/program-broadcast-filters';

import { useDebounce } from './useDebounce';

const DEBOUNCE_TIME = 600;

type DebouncedArrayFilters = Pick<
  ProgramBroadcastFiltersState,
  'logos' | 'people' | 'programs' | 'broadcasters' | 'workspaces' | 'projects' | 'tags'
>;

export function useDebouncedBroadcastFilters(
  filters: DebouncedArrayFilters
): DebouncedArrayFilters {
  return {
    logos: useDebounce(filters.logos, DEBOUNCE_TIME) as string[],
    people: useDebounce(filters.people, DEBOUNCE_TIME) as string[],
    programs: useDebounce(filters.programs, DEBOUNCE_TIME) as string[],
    broadcasters: useDebounce(filters.broadcasters, DEBOUNCE_TIME) as string[],
    workspaces: useDebounce(filters.workspaces, DEBOUNCE_TIME) as string[],
    projects: useDebounce(filters.projects, DEBOUNCE_TIME) as string[],
    tags: useDebounce(filters.tags, DEBOUNCE_TIME) as string[],
  };
}
